<div class="content-wrapper container-xxl p-0">
  <div class="content-body">
    <app-content-header [contentHeader]="contentHeader"></app-content-header>
    <div class="card">
      <div class="card-title w-100 p-2 mb-0">
        <div class="row justify-content-between align-items-center">
          <div class="col-md-9 col-12 row">
            <div class="col-lg-3 col-12">
              <input id="datatable-search-input" type="search" [placeholder]="'SEARCH' | translate" class="form-control" [ngClass.xl]="'pl-1'" [(ngModel)]="searchKeyword" />
            </div>
            <div class="col-lg-3 col-12">
              <ng-select [(ngModel)]="filterRequireNote" [clearable]="false" [closeOnSelect]="true" [searchable]="false" [openOnEnter]="false" [virtualScroll]="true" (change)="absencesList()">
                <ng-template ng-label-tmp let-item="item">
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "DATATABLE_COLUMNS.REQUIRE_NOTE" | translate }}: {{ "NO" | translate }}</span>
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "DATATABLE_COLUMNS.REQUIRE_NOTE" | translate }}: {{ "YES" | translate }}</span>
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===3">{{ "DATATABLE_COLUMNS.REQUIRE_NOTE" | translate }}</span>
                </ng-template>
                <ng-option [value]="3"><span class="font-small-4 font-weight-normal">{{ "ALL" | translate }}</span></ng-option>
                <ng-option [value]="1"><span class="font-small-4 font-weight-normal">{{ "REQUIRED" | translate }}</span></ng-option>
                <ng-option [value]="0"><span class="font-small-4 font-weight-normal">{{ "NOT_REQUIRED" | translate }}</span></ng-option>
              </ng-select>
            </div>
            <div class="col-lg-3 col-12">
              <ng-select [(ngModel)]="filterRequireFile" [clearable]="false" [closeOnSelect]="true" [searchable]="false" [openOnEnter]="false" [virtualScroll]="true" (change)="absencesList()">
                <ng-template ng-label-tmp let-item="item">
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===0">{{ "DATATABLE_COLUMNS.REQUIRE_FILE" | translate }}: {{ "NO" | translate }}</span>
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===1">{{ "DATATABLE_COLUMNS.REQUIRE_FILE" | translate }}: {{ "YES" | translate }}</span>
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item===3">{{ "DATATABLE_COLUMNS.REQUIRE_FILE" | translate }}</span>
                </ng-template>
                <ng-option [value]="3"><span class="font-small-4 font-weight-normal">{{ "ALL" | translate }}</span></ng-option>
                <ng-option [value]="1"><span class="font-small-4 font-weight-normal">{{ "REQUIRED" | translate }}</span></ng-option>
                <ng-option [value]="0"><span class="font-small-4 font-weight-normal">{{ "NOT_REQUIRED" | translate }}</span></ng-option>
              </ng-select>
            </div>
            <div class="col-lg-3 col-12">
              <ng-select id="type" class="font-small-4 font-weight-normal" bindLabel="name" [(ngModel)]="filterTypeAbsence" (change)="absencesList()"
                         [searchable]="true" [closeOnSelect]="true" [clearable]="false" [openOnEnter]="false" [virtualScroll]="true">
                <ng-template ng-label-tmp let-item="item">
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item!='0'">{{ "DATATABLE_COLUMNS.TYPE" | translate }}: {{ item | titlecase }}</span>
                  <span class="font-small-4 font-weight-normal pr-2" *ngIf="item=='0'">{{ "TYPE_ABSENCE" | translate }}</span>
                </ng-template>
                <ng-option [value]="'0'">{{ 'ALL' | translate }}</ng-option>
                <ng-option *ngFor="let typeOfAbsence of _absencesService.typeAbsence" [value]="typeOfAbsence">{{ "TYPE_ABSENCES." + typeOfAbsence | translate }}</ng-option>
              </ng-select>
            </div>
            <div *ngIf="_utilService.isMobile || _utilService.isTablet">
              <a class="btn btn-outline-primary text-primary w-100" *ngIf="_authenticationService.hasCapability('create_absence_type')" [routerLink]="'/dashboard/absence/add'">{{ "ADD" | translate }}</a>
            </div>
          </div>
          <div class="col-md-3 col-12 text-right" *ngIf="_utilService.isDesktop">
            <div class="d-inline-block mr-2">
              <app-select-table-limit [defaultValue]="tableLimit" (onChange)="tableLimit = $event"></app-select-table-limit>
            </div>
            <a class="btn btn-outline-primary text-primary" *ngIf="_authenticationService.hasCapability('create_absence_type')" [routerLink]="'/dashboard/absence/add'">{{ "ADD" | translate }}</a>
          </div>
        </div>
      </div>

      <div class="card-body p-0" *ngIf="_utilService.isDesktop">
        <ngx-datatable class="bootstrap core-bootstrap" columnMode="force" [headerHeight]="30" [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }" [scrollbarH]="true"
                       [rows]="filteredAbsences" [rowHeight]="_utilService.isDesktop ? 70 : 90" [limit]="tableLimit" [footerHeight]="60">
          <ngx-datatable-column [name]="'DATATABLE_COLUMNS.CODE' | translate" prop="code" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.code }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" prop="name" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.name }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DATATABLE_COLUMNS.TYPE_ABSENCE' | translate" prop="type" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.type | titlecase }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DATATABLE_COLUMNS.REQUIRE_NOTE' | translate" prop="require_note" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.require_note ? 'YES' : 'NO') | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DATATABLE_COLUMNS.REQUIRE_FILE' | translate" prop="require_file" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ (row.require_file ? 'YES' : 'NO') | translate }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column [name]="'DATATABLE_COLUMNS.USES_NUMBER' | translate" prop="used" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <span>{{ row.used }}</span>
            </ng-template>
          </ngx-datatable-column>
          <ngx-datatable-column name="{{ 'ACTIONS' | translate }}" [sortable]="false">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div>
                <button class="bg-transparent border-0 text-secondary pr-1" [routerLink]="'/dashboard/absence/edit/' + row.id" *ngIf="_authenticationService.hasCapability('edit_absence_type')">
                  <i [data-feather]="'edit-2'" size="19"></i>
                </button>
                <button (click)="deleteTypeAbsence(row)" class="bg-transparent border-0 text-danger remove-item" *ngIf="_authenticationService.hasCapability('delete_absence_type')">
                  <i [data-feather]="'trash-2'" size="19"></i>
                </button>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>

      <div class="card-body px-0 pb-0" *ngIf="_utilService.isMobile || _utilService.isTablet">
        <ngx-datatable
          class="bootstrap core-bootstrap"
          columnMode="force"
          [headerHeight]="config.headerHeight"
          [messages]="{ emptyMessage: ('NO_DATA_TO_DISPLAY' | translate) }"
          [scrollbarH]="false"
          [rows]="filteredAbsences"
          [rowHeight]="110"
          [limit]="tableLimit"
          [footerHeight]="config.footerHeight"
        >
          <ngx-datatable-column [name]="'FIRSTNAME' | translate" [prop]="'name'" [width]="300" [sortable]="true">
            <ng-template ngx-datatable-cell-template let-row="row">
              <div class="row" [ngClass.sm]="'list-item-mobile'">
                <div class="col-12 text-break-line-1">{{ row.name }}</div>
                <div class="col-12 font-small-4">
                  <span>{{ "DATATABLE_COLUMNS.REQUIRE_NOTE" | translate }}: {{ row.require_note }}</span>
                  <span class="d-inline-block ml-1">{{ "DATATABLE_COLUMNS.REQUIRE_FILE" | translate }}: {{ row.require_file }}</span>
                </div>
                <div class="col-12">
                  <button class="bg-transparent border-0 text-secondary pr-1" *ngIf="_authenticationService.hasCapability('edit_absence_type')" [routerLink]="'/dashboard/absence/edit/' + row.id">
                    <i [data-feather]="'edit-2'" size="19"></i>
                  </button>
                  <button (click)="deleteTypeAbsence(row)" *ngIf="_authenticationService.hasCapability('delete_absence_type')" class="bg-transparent border-0 text-danger remove-item">
                    <i [data-feather]="'trash-2'" size="19"></i>
                  </button>
                </div>
              </div>
            </ng-template>
          </ngx-datatable-column>
        </ngx-datatable>
      </div>
    </div>
  </div>
</div>
